import RobotFace from "@/components/RobotFace";

/**
 * RobotBody — a simple physical-Rammy preview: RobotFace inside a rounded
 * chassis silhouette. Used on marketing hardware section + admin device pages.
 */
export default function RobotBody({ expression = "happy", size = 280 }) {
  return (
    <div
      className="mx-auto"
      style={{ width: size, height: Math.round(size * 1.2) }}
      aria-label="Rammy hardware preview"
    >
      {/* Head */}
      <div
        className="rounded-[36%_36%_32%_32%/40%_40%_28%_28%] bg-[var(--rm-ink-900)] flex items-center justify-center rammy-shadow-lg"
        style={{ width: size, height: Math.round(size * 0.72) }}
      >
        <RobotFace expression={expression} size={Math.round(size * 0.55)} round showHud={false}/>
      </div>
      {/* Neck */}
      <div
        className="mx-auto bg-[var(--rammy-text-muted)]"
        style={{ width: Math.round(size * 0.18), height: Math.round(size * 0.08), borderRadius: 4 }}
      />
      {/* Base */}
      <div
        className="mx-auto rounded-[46%_46%_18%_18%/58%_58%_20%_20%] bg-gradient-to-b from-[var(--rammy-text-muted)] to-[var(--rammy-text)] rammy-shadow"
        style={{ width: Math.round(size * 0.9), height: Math.round(size * 0.36), marginTop: -2 }}
      />
    </div>
  );
}

export { RobotBody };
